import type * as React from 'react';

import { cn } from '../../styles/lib/utils';
import { Icon } from '../Icon';
import { Tooltip } from '../Tooltip';
import { FieldLabel, FieldRequired } from './Field';

type FieldLabelRowProps = React.ComponentProps<typeof FieldLabel> & {
  isRequired?: boolean;
  tooltipText?: React.ReactNode;
  secondaryAction?: React.ReactNode;
  tooltipTestId?: string;
};

function FieldLabelRow({
  id,
  htmlFor,
  className,
  children,
  isRequired,
  tooltipText,
  secondaryAction,
  tooltipTestId,
  ...props
}: FieldLabelRowProps) {
  return (
    <div className="flex items-center gap-2 leading-snug">
      <FieldLabel id={id} htmlFor={htmlFor} className={cn('gap-1 text-xs', className)} {...props}>
        {children}
        {isRequired && <FieldRequired className="text-xs" />}
      </FieldLabel>
      {tooltipText && (
        <Tooltip
          text={tooltipText}
          delayDuration={200}
          sideOffset={10}
          className="max-w-[30rem]"
          aria-label={typeof children === 'string' ? `About ${children}` : 'More information'}
          triggerClassName="flex rounded-sm"
          data-testid={tooltipTestId}
        >
          <Icon icon="questionMarkCircled" size={12} className="text-primary" />
        </Tooltip>
      )}
      {secondaryAction}
    </div>
  );
}

export { FieldLabelRow };
export type { FieldLabelRowProps };
